import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=8bd8cf72&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.css?vue&type=style&index=0&id=8bd8cf72&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd8cf72",
  null
  
)

export default component.exports